import ApiClient from '@/services/api-client';
const api = new ApiClient();

export interface VerifyInvitationRequest {
  token: string;
  email: string;
}

export interface VerifyInvitationResponse {
  name?: string;
  provider?: { name?: string };
  expiresAt?: string;
}

export interface AcceptInvitationRequest {
  token: string;
  email: string;
  password: string;
  password_confirmation: string;
  language?: string;
}

export interface AcceptInvitationResponse {
  id: string;
  email: string;
  name?: string;
}

export async function verifyInvitation(body: VerifyInvitationRequest) {
  const res = await api.post<VerifyInvitationResponse, VerifyInvitationRequest>(`/api/v1/customer/invitation/verify`, body, {
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  });
  return res.data;
}

export async function acceptInvitation(body: AcceptInvitationRequest) {
  const res = await api.post<AcceptInvitationResponse, AcceptInvitationRequest>(`/api/v1/customer/invitation/accept`, body, {
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  });
  return res.data;
}
